import { FC, useState } from 'react';
import { StaffEventsViewProps } from './staffEvents.interfaces';
import { useStaffEventsState } from '../../contexts/staffEvents.context';
import { Box } from '@mui/material';
import CalendarComponent from '../../../../components/calendarComponent/calendarComponent';
import { EventClickArg } from '@fullcalendar/core';
import AddEventComponent from '../../../../components/addEventComponent/addEventComponent.view';
import { TEventsPrimary } from '../../../../../apis/events/events.interfaces';
import { useTranslation } from '../../../../../hooks/useTranslationHook';
import { PermissionGate } from '../../../../../components/rbac/PermissionGate';
import { RbacDeniedRedirect } from '../../../../../components/rbac/RbacDeniedRedirect';

const StaffEventsView: FC<StaffEventsViewProps> = () => {
  const { translateText } = useTranslation();
  const { filteredEvents: staffEvents } = useStaffEventsState();
  const [isAddEventModalOpen, setIsAddEventModalOpen] = useState(false);

  const eventsForCalendar = staffEvents.map((eachEvent) => ({
    title: eachEvent.title,
    date: eachEvent.startDate,
  }));

  const handleDateClick = (date: Date) => {
    setIsAddEventModalOpen(true);
  };

  const handleEventClick = (event: EventClickArg) => {
    setIsAddEventModalOpen(true);
  };

  const handleCloseAddEventModal = () => {
    setIsAddEventModalOpen(false);
  };

  const handleSubmitAddEvent = (event: Partial<TEventsPrimary>) => {
    console.log('Event submitted:', event.title);
  };

  return (
    <PermissionGate
      module="staff"
      submodule="events"
      permission="read"
      fallback={<RbacDeniedRedirect />}
    >
      <Box
        data-testid="staff-events-view"
        sx={{
          px: { xs: 1, sm: 2 },
          pt: { xs: 1, sm: 2 },
          pb: { xs: 2, sm: 4 },
        }}
      >
        <CalendarComponent
          events={eventsForCalendar}
          onDateClick={handleDateClick}
          onEventClick={handleEventClick}
        />
        <AddEventComponent
          isOpen={isAddEventModalOpen}
          onClose={handleCloseAddEventModal}
          onSubmit={handleSubmitAddEvent}
          title={translateText('students.events.addEvent')}
          description={translateText('students.events.addNewEvent')}
          eventDetails={null}
          isLoading={false}
          errorMessage=""
        />
      </Box>
    </PermissionGate>
  );
};

export default StaffEventsView;
